/**
 * The standing statements, written once.
 *
 * These are the sentences that say what this service is and is not. They appear on more than one
 * screen and they must appear identically — a disclaimer that is worded three slightly different
 * ways in three places is three different claims.
 *
 * They live here as **string constants rather than JSX text** for a mechanical reason worth
 * knowing. The language check reads a line at a time, and the exception that permits a forbidden
 * word is a clause that explicitly denies it. Prettier reflows JSX text to the print width, which
 * had already split "It does not" from "diagnose, treat, or cure" twice and failed the build both
 * times. Prettier does not reflow a string literal, so the denial and the words it denies stay on
 * one line permanently.
 */

/** The service, in one sentence. Used in the page footer and the document description. */
export const WHAT_THIS_IS =
  'An educational and reflective service. It does not diagnose, treat, or cure anything, and it does not replace dental, medical, or psychological care.';

/** Shown beneath the chart panel, where someone is recording their own history. */
export const CHART_FOOTNOTE =
  'This is your own account of what you remember. It is material for reflection. It does not diagnose, treat, or cure anything, and nothing here is a professional opinion about your mouth.';
